import React from 'react';
import './App.css';
import LocationPermissionChecker from './LocationPermissionChecker';

function App() {
  return LocationPermissionChecker();
}

export default App;
